<div class="container">
  <h1 i18n>Quejas y Sugerencias</h1>
  <div class="dakkini-card mt-4">
    <p class="m-0 fs-14px" i18n>Nos esforzamos por brindar la mejor experiencia posible a nuestros usuarios. Por
      eso, queremos animarte a utilizar nuestro buzón de "quejas y sugerencias". Sabemos que la retroalimentación
      es esencial para mejorar nuestros servicios y productos, y es por eso que valoramos tus comentarios y
      opiniones.</p>
    <p class="m-0 fs-14px mt-3" i18n>Si tienes alguna sugerencia o queja, por favor no dudes en comunicárnosla a
      través del correo electrónico <strong><a class="text-dark"
          href="mailto:{{this.contactEmail}}">{{this.contactEmail}}</a></strong>. Nos aseguraremos de que tus
      comentarios sean escuchados y tomados en cuenta para futuras mejoras.</p>
    <p class="m-0 fs-14px mt-3" i18n>¡Gracias por confiar en nosotros y esperamos tus comentarios!</p>
    <a class=" mt-5 btn mx-auto form__button fw-bold px-5 align-middle d-grid align-items-center"
      href="mailto:{{this.contactEmail}}" i18n>Contactar ahora</a>
  </div>
</div>